import { DCBaseKeyEvent } from "./DCBaseKeyEvent.js";
export class DCKeyUpEvent extends DCBaseKeyEvent {
    eventType = "keyboard-down";
    inputType = "keyboard";
    constructor() {
        super();
    }
}
